import { useState } from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaStar, FaArrowRight } from 'react-icons/fa';
import './Contact.css';
import SEOHead from '../../components/SEOHead';


function Contact() {
  const [rating, setRating] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleRating = (index) => {
    setRating(index);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    // Simulate network request
    setTimeout(() => {
      setLoading(false);
      alert("Message sent successfully!");
    }, 1500);
  };

  return (
    <div className="contact-split-container">
      <SEOHead
        title="Contact WeCare EHS | Safety Training & Consultancy Enquiries"
        description="Get in touch with WeCare EHS. Contact us for workplace safety training, EHS consultancy, ISO certification, and audit services. Mumbai, India. Call +91 8657181972."
        keywords="contact WeCare EHS, safety training enquiry, EHS consultancy contact, Mumbai safety training"
        canonical="/contact"
      />

      {/* LEFT PANEL: INFO & VISUALS */}
      <div className="contact-visual-panel">
        <div className="contact-visual-content">
          <h1 className="contact-heading">Let's start a<br /><span className="highlight-text">conversation.</span></h1>
          <p className="contact-subtext">
            Have a question about our safety training or consultancy services?
            Our team is ready to help you build a safer workplace.
          </p>

          <div className="contact-details-grid">
            <div className="detail-card">
              <FaPhoneAlt className="detail-icon" />
              <div>
                <h5>Call Us / Whatsapp</h5>
                <p>+91 8657181972</p>
              </div>
            </div>

            <div className="detail-card">
              <FaEnvelope className="detail-icon" />
              <div>
                <h5>Email Us</h5>
                <p>wecareehs@gmail.com</p>
              </div>
            </div>

            <div className="detail-card">
              <FaMapMarkerAlt className="detail-icon" />
              <div>
                <h5>Location</h5>
                <p>Mumbai, Maharashtra, India</p>
              </div>
            </div>
          </div>

          <div className="abstract-shape contact-shape"></div>
        </div>
      </div>

      {/* RIGHT PANEL: FORM */}
      <div className="contact-form-panel">
        <div className="form-content contact-form-width">

          <div className="login-header">
            <h2>Send a Message</h2>
            <p>We usually respond within 24 hours.</p>
          </div>

          <form onSubmit={handleSubmit} className="split-form">
            <div className="minimal-input-group">
              <label>Your Name</label>
              <input type="text" className="minimal-input" placeholder="John Doe" required />
            </div>

            <div className="minimal-input-group">
              <label>Email Address</label>
              <input type="email" className="minimal-input" placeholder="john@company.com" required />
            </div>

            <div className="minimal-input-group">
              <label>Message</label>
              <textarea
                className="minimal-input minimal-textarea"
                placeholder="How can we help you?"
                rows="2"
                required
              ></textarea>
            </div>

            <button type="submit" className="action-btn" disabled={loading}>
              {loading ? "Sending..." : "Send Message"} <FaArrowRight />
            </button>
          </form>

          {/* Feedback Mini-Section */}
          <div className="feedback-mini-section">
            <p>Rate your experience:</p>
            <div className="stars">
              {[1, 2, 3, 4, 5].map((index) => (
                <FaStar
                  key={index}
                  className={`star-icon ${index <= rating ? 'active' : ''}`}
                  onClick={() => handleRating(index)}
                />
              ))}
            </div>
          </div>

        </div>
      </div>

    </div>
  );
}

export default Contact;